import * as types from './types';

const initialState = {
  YusaOvernightCampRevenueList: {},
  YusaOvernightCampGetExpensesList: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };

    case types.YUSA_OVERNIGHT_CAMP_GET_REVENUE_SUCCESS: {
      return {
        ...state,
        YusaOvernightCampRevenueList: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_GET_REVENUE_FAILURE:
      return { ...state, error: action.payload };
    case types.YUSA_OVERNIGHT_CAMP_REVENUE_LIST_SUCCESS: {
      return {
        ...state,
        YusaOvernightCampFinancialsList: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_REVENUE_LIST_FAILURE:
      return { ...state, error: action.payload };
    case types.YUSA_OVERNIGHT_CAMP_GET_EXPENSES_SUCCESS: {
      return {
        ...state,
        YusaOvernightCampGetExpensesList: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_GET_EXPENSES_FAILURE:
      return { ...state, error: action.payload };
    case types.YUSA_OVERNIGHT_CAMP_EXPENSES_LIST_SUCCESS: {
      return {
        ...state,
        YusaOvernightCampGetExpensesList: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_EXPENSES_LIST_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
